import Resource from '@/plugins/sdk/Resource'
import { DATETIME, NUMBER, BOOLEAN, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'inv_pricing'

  static get fields () {
    return {
      id: new UUID(),
      inv_pricing_id: new NUMBER(),
      con_pricing_id: new NUMBER(),
      inv_pricing_date: new DATETIME(),
      buy_rate: new NUMBER(),
      buy_fees: new NUMBER(),
      buy_fuel: new NUMBER(),
      buy_tax: new NUMBER(),
      sell_rate: new NUMBER(),
      sell_fees: new NUMBER(),
      sell_fuel: new NUMBER(),
      sell_tax: new NUMBER(),
      hand_rated: new BOOLEAN(),
      accepted: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
